// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3wC9s","range":"MonthRangeSwitch_range__3_tx8","disabled":"MonthRangeSwitch_disabled__uig3-"};